<template>
  <div class="page-content">
    <page-template ref="summaryTemplate"
                   :tableOptions="tableOptions"
                   :searchOptions="searchOptions"
                   :toolConfig="toolConfig"
    ></page-template>
    <el-dialog
      title="商品列表"
      :visible.sync="listShow"
      width="1200px"
      height="2000px"
      :close-on-click-modal="false"
    >
      <list-template :tableOptions="listColumns" :tableData="listColumnsTableData" ref="listOperation">
      </list-template>
    </el-dialog>
    <el-dialog
      title="组合支付详情"
      :visible.sync="showBox"
      width="1000px"
      height="2000px"
      :close-on-click-modal="false"
    >
      <list-template :tableOptions="cashierReportListColumns" :tableData="reportListTableData"
                     ref="cashierReportListOperation">
      </list-template>
    </el-dialog>
  </div>
</template>

<script>
  import pageTemplate from '@/components/template/pageTemplate';
  import listTemplate from '@/components/template/listTemplate';
  import api from '@/config/api';
  import userPower from '@/mixin/userPower';

  export default {
    mixins: [userPower],
    components: {
      pageTemplate,
      listTemplate,
    },
    data() {
      return {
        dialogVisibility: false,
        listShow: false,
        showBox: false,
        // 高级搜索条件
        searchOptions: {
          simple: [
            {
              label: '',
              type: 'input',
              prop: 'orderNo',
              isFuzzy: true,
              placeholder: '订单号/会员名称',
            },
          ],
          complex: [
            {
              label: '选择日期',
              prop: 'CreateDttm',
              type: 'dateTimeRangeButton',
              dateType: 'datetime',
              span: 24,
            },
            {
              label: '门店名称',
              type: 'select',
              prop: 'storeId',
              span: 12,
              data: [],
              change: this.getCashierChange,
              url: api.store.store,
            },
            {
              label: '收银员',
              type: 'select',
              prop: 'cashierId',
              data: [],
              span: 12,
              // param: {type: 40},
              // url: api.system.type,
            },
            {
              label: '消费类型',
              prop: 'orderType',
              type: 'select',
              span: 12,
              data: this.$utils.getCacheStatus('soBillOrder.orderType')
            },
            {
              label: '支付方式',
              prop: 'payType',
              type: 'select',
              span: 12,
              data: this.$utils.getCacheStatus('soBillOrder.payType')
            },
          ],
        },
        // 更多功能
        toolConfig: [
          {
            label: '查看详情',
            type: this.$utils.buttonType.tableOperate,
            callback: this.checkGoods,
            code: 'record',
          },
          {
            label: 'wifi打印',
            code: '',
            type: this.$utils.buttonType.tableOperate,
          },
          {
            label: '打印订单',
            code: '',
            type: this.$utils.buttonType.tableOperate,
          },
          {
            label: '设置',
            code: 'set',
          },
          {
            label: '打印',
            code: 'print',
          },
          {
            label: '导出',
            code: 'export',
            callback: this.exportExcel
          },
        ],
        //弹出框表格字段
        listColumnsTableData: [],
        listColumns: {
          disabled: false,
          indexShow: true, //是否显示索引
          summaryColumns: ['retailPrice', 'payPrice', 'goodsNum', 'allPrice'],
          columns: [
            {
              label: '商品名称',
              prop: 'goodsName',
              width: '100',
            },
            {
              label: '条码',
              prop: 'artNo',
              width: '150',
            },
            {
              label: '自编码',
              prop: 'barCode',
              width: '150',
            },
            {
              label: '规格',
              prop: 'specs',
              width: '80',
            },

            {
              label: '单位',
              prop: 'goodsUnitName',
              align: 'center',
              width: '80',
            },
            {
              label: '零售价',
              prop: 'retailPrice',
              align: 'center',
              width: '80',
            },
            {
              label: '售价',
              prop: 'payPrice',
              align: 'center',
              width: '80',
            },
            {
              label: '购买数量',
              prop: 'goodsNum',
              align: 'center',
              width: '80',
            },
            {
              label: '小计金额',
              prop: 'allPrice',
              align: 'center',
              width: '80',
            },
          ],
          url: api.retail.retailSearch,
        },
        reportListTableData: [],
        cashierReportListColumns: {
          disabled: false,
          indexShow: true, //是否显示索引
          summaryColumns: ['payPrice'],
          columns: [
            {
              label: '订单号',
              prop: 'tradeNo',
              width: '100',
            },
            {
              label: '支付方式',
              prop: 'payType',
              width: '100',
              enumData: this.$utils.getCacheStatus("soBillOrder.payType")
            },
            {
              label: '支付金额',
              prop: 'payPrice',
              width: '100',
            },
            {
              label: '支付时间',
              prop: 'createDttm',
              width: '100',
            },
          ],
        },
        // 表格信息配置
        tableOptions: {
          showSummary: true,
          summaryColumns: ['amountReceived'],
          indexShow: true, //是否显示索引
          indexMethod: (index) => {
            //自定义列索引
            return index + 1;
          },
          columns: [
            {
              label: '订单号',
              prop: 'orderNo',
              width: '170',
              align: 'center',
            },
            {
              label: '消费门店',
              prop: 'storeName',
              width: '120',
              align: 'center',
            },
            {
              label: '消费类型',
              prop: 'orderType',
              width: '100',
              align: 'center',
              enumData: this.$utils.getCacheStatus('soBillOrder.orderType'),
            },
            {
              label: '支付方式',
              prop: 'payType',
              width: '100',
              align: 'center',
              enumData: this.$utils.getCacheStatus('soBillOrder.payType'),
            },
            {
              label: '支付金额',
              prop: 'amountReceived',
              width: '100',
              callback: this.showDetailBox,
              align: 'center'
            },
            {
              label: '支付时间',
              prop: 'createDttm',
              width: '150',
              align: 'center',
            },
            {
              label: '会员姓名',
              prop: 'memberName',
              width: '100',
              align: 'center',
            },
            {
              label: '收银员',
              prop: 'cashierName',
              width: '100',
              align: 'center',
            },
          ],
          url: api.retail.retailSearch,
        },
      };
    },
    created() {
      this.setStore(this.searchOptions.complex);
      //this.setSupplier(this.searchOptions.complex);
      this.getCashier();
    },
    methods: {
      typeChange(a) {
        console.log(a)
      },
      checkGoods(row) {
        this.$axios
          .fetchGet(api.retail.retailSearch + '?id=' + row.id)
          .then((data) => {
            if (data.code === 200) {
              this.listShow = true;
              this.listColumnsTableData = data.data['soBillOrderGoodsMapMVOList'];
            }
          })
          .catch((err) => {
            console.log(err);
            this.$message({message: '请求失败！', type: 'error'});
          });


      },
      getCashier() {
        let userInfo = this.$utils.getSysUser();
        if (userInfo.storeId) {
          this.$axios.fetchPost(api.system.type + '/list', {type: 40}).then(data => {
            if (data.code === 200) {
              this.searchOptions.complex.filter(item => item.prop === 'cashierId')[0].data = data.data;
            }
          })
        }
      },
      getCashierChange(form) {
        form.cashierId = '';
        this.$axios.fetchPost(api.system.type + '/list', {storeId: form.storeId, type: 40}).then(data => {
          if (data.code === 200) {
            this.searchOptions.complex.filter(item => item.prop === 'cashierId')[0].data = data.data;
          }
        })
      },
      exportExcel() {
        let params = this.$refs["summaryTemplate"].getCurrentParams();
        params.exportCode = "SoBillOrderExport";
        this.$axios.fetchPost(api.store.summarySummaryExport, params).then(data => {
          if (data.code === 200) {
            const elink = document.createElement('a');
            elink.href = data.data;
            elink.click();
            this.loadingExt = false;
            this.$notify({
              type: "success",
              title: '导出操作',
              message: '成功',
              showClose: false,
            });
            // this.$message({message: '导出成功', type: 'success'});
          } else {
            this.$notify({
              type: "error",
              title: '导出操作',
              message: '失败',
              showClose: false,
            });
            // this.$message({message: '导出异常', type: 'error'});
          }
        })
      },
      showDetailBox(data) {
        this.$axios
          .fetchPost(api.retail.payDetail, {tradeNo: data.orderNo})
          .then((data) => {
            if (data.code === 200) {
              this.reportListTableData = data.data;
              this.showBox = true;
            }
          })
          .catch((err) => {
            console.log(err);
            this.$message({message: '请求失败！', type: 'error'});
          });
      }
    },
  };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/store/pay/Summary.vue